<script lang="ts">
import { defineComponent, ref } from "vue";
import Tarifoption from "@/components/tarifoptionen/Tarifoption.vue";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Tarifoptionen.vue",
  components: { Tarifoption },
  props: {
    tarifoptionentitel: {
      type: String,
      required: false,
    },
    tarifoptionInformationen: Array,
  },
  setup(props) {
    const piniaStore = useFormStore();
    const tarifOptionData = ref(props.tarifoptionInformationen);

    function istLetzteSichtbareTarifoption(name: string) {
      const letzteSichtbareTarifOption = letzteSichtbareTarifoption();
      return letzteSichtbareTarifOption !== null && letzteSichtbareTarifOption.typ === name;
    }

    function letzteSichtbareTarifoption() {
      if (props.tarifoptionInformationen) {
        for (let i = props.tarifoptionInformationen.length - 1; i >= 0; i--) {
          const option: any = props.tarifoptionInformationen[i];
          const optionTyp = option.typ;
          if (!piniaStore.state.tarifOptionenZuVerbergen.includes(optionTyp)) {
            return option;
          }
        }
        return null;
      }
    }

    return {
      piniaStore,
      tarifOptionData,
      props,
      istLetzteSichtbareTarifoption,
    };
  },
});
</script>

<template>
  <div id="tariffOptionsTable" class="o-grid">
    <div class="o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y">
      <h2 v-if="props.tarifoptionentitel === undefined" class="u-form-heading unset-text-align">
        {{ piniaStore.state.isMakler ? "Tarifmerkmale" : "Tarifoptionen" }}
      </h2>
    </div>
  </div>

  <div class="tarifoptions-table">
    <tarifoption
      v-for="tarifoptionInformation in tarifOptionData"
      :key="tarifoptionInformation.typ"
      :tarifoptionInformation="tarifoptionInformation"
      :ist-letzte-tarifoption="istLetzteSichtbareTarifoption(tarifoptionInformation.typ)"
      :tarifoptionentitel="props.tarifoptionentitel"
    />
  </div>
</template>
